import React, { useState, useCallback } from 'react';
import classNames from 'classnames';
import MatchCard from './components/MatchCard';
import styles from './Matches.module.scss';

const STATUS = {
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS',
  SCHEDULED: 'SCHEDULED',
};

const ChevronIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="16" cy="16" r="16" fill="rgba(255, 255, 255, 0.15)" />
    <path
      d="M11 18.5 L16 13.5 L21 18.5"
      stroke="#FFFFFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Matches = ({ matches, selectedTeamId, onMatchClick }) => {
  const [pastLoaded, setPastLoaded] = useState(false);

  const togglePast = useCallback(() => {
    setPastLoaded(prev => !prev);
  }, []);

  if (!matches || matches.length === 0) {
    return (
      <div className={styles['matches']}>
        <p className={styles['matches__empty']}>No hay partidos disponibles.</p>
      </div>
    );
  }

  const pastMatches = matches.filter(m => m.status === STATUS.COMPLETED);
  const activeMatches = matches.filter(m => m.status !== STATUS.COMPLETED);
  const visibleMatches = pastLoaded ? matches : activeMatches;

  return (
    <div className={styles['matches']}>
      {pastMatches.length > 0 && (
        <button
          type="button"
          onClick={togglePast}
          className={styles['matches__filter-trigger']}
        >
          <span
            className={classNames(styles['matches__filter-icon'], {
              [styles['matches__filter-icon--open']]: pastLoaded,
            })}
          >
            <ChevronIcon />
          </span>
          <span className={styles['matches__filter-label']}>
            Partidos anteriores
          </span>
        </button>
      )}

      <div className={styles['matches__grid']}>
        {visibleMatches.map(match => (
          <MatchCard
            key={match.matchId}
            match={match}
            selectedTeamId={selectedTeamId}
            onMatchClick={onMatchClick}
          />
        ))}
      </div>
    </div>
  );
};

export default Matches;
